import React from "react";
import CTAButton from "../CTAButton/CTAButton";
import "./Home.css";
import signup from '../../assets/signup.png';
import Segment from "../../assets/segment.png";
import AiEmailMarketing from "../../assets/AIEmailMarketing.png";
import sub from "../../assets/new_sub.png";
import support from "../../assets/support.png";
import Slider from "../Slider";
import templateOne from "../../assets/templeteimages/d1oco4z2z1fhwp-cloudfront-net-templates-default-1861-html-06-28-2026_08_19_PM.png";
import templateTwo from "../../assets/templeteimages/d1oco4z2z1fhwp-cloudfront-net-templates-default-4566-html-06-28-2026_08_20_PM.png";
import templateThree from "../../assets/templeteimages/d1oco4z2z1fhwp-cloudfront-net-templates-default-6351-html-06-28-2026_08_20_PM.png";
import templateFour from "../../assets/templeteimages/d1oco4z2z1fhwp-cloudfront-net-templates-default-7676-html-06-28-2026_08_19_PM.png";
import templateFive from "../../assets/templeteimages/d1oco4z2z1fhwp-cloudfront-net-templates-default-10426-html-06-28-2026_08_20_PM.png";
import templateSix from "../../assets/templeteimages/d1oco4z2z1fhwp-cloudfront-net-templates-default-10461-html-06-28-2026_08_20_PM.png";
import templateSeven from "../../assets/templeteimages/d1oco4z2z1fhwp-cloudfront-net-templates-default-10516-html-06-28-2026_08_19_PM.png";
import templateEight from "../../assets/templeteimages/Spooktacular-offers-06-28-2026_08_19_PM.png";
import { Link } from 'react-router-dom';
import ainew from "../../assets/new/Marketing Automation That Saves Time and Increases Productivity mailsnappy.png";
import useDragScroll from "../../hooks/useDragScroll";


const templateSlides = [
  { image: templateOne, title: "Retail launch", path: "/templates" },
  { image: templateTwo, title: "Editorial picks", path: "/templates" },
  { image: templateThree, title: "Fresh market", path: "/templates" },
  { image: templateFour, title: "Product spotlight", path: "/templates" },
  { image: templateFive, title: "Back to school", path: "/templates" },
  { image: templateSix, title: "Seasonal offer", path: "/templates" },
  { image: templateSeven, title: "Premium promo", path: "/templates" },
  { image: templateEight, title: "Holiday sale", path: "/templates" },
];


const Home = () => {
  const templateDragScroll = useDragScroll({ loop: true, auto: true, speed: 0.34 });
  const templateLoop = [...templateSlides, ...templateSlides, ...templateSlides];

  return (
    <div className="home">
      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-flower hero-flower-left" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="hero-flower hero-flower-right" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="hero-content">
          <h1>Email Marketing Software That Helps You Grow Faster</h1>
          <p>
            Mailsnappy makes it easier to connect with your audience, increase sales, and build lasting customer relationships. MailSnappy is an <Link className="linkcolor" to="/email-marketing-platform">AI powered email marketing platform</Link> that helps businesses create professional email campaigns, automate communication, manage subscribers, and track campaign performance from one simple dashboard. Whether you run an ecommerce store, SaaS company, agency, or small business, MailSnappy gives you the tools to send better emails with less effort.
          </p>
          <div className="hero-form"><CTAButton>Get started for free</CTAButton></div>
          <span className="hero-note">No credit card required</span>
        </div>
        <div className="hero-mascot" aria-hidden="true" />
        <div className="hero-wave"></div>
      </section>
<Slider />

      <section className="template-showcase template-showcase-fluid" aria-label="Beautiful email templates">
        <div className="template-showcase-head">
          <span>Template gallery</span>
          <h2>Email Marketing Templates Designed for Better Campaigns</h2>
          <p>
            Create beautiful email campaigns using professionally designed email templates that are fully responsive across desktop and mobile devices. Customize every section with your own branding, images, colors, and messaging using our easy email builder. No coding experience is required, allowing anyone to create professional marketing emails in minutes.
          </p>
        </div>
        <div className="template-slider draggable-carousel" {...templateDragScroll}>
          <div className="template-slider-track">
            {templateLoop.map((template, index) => (
              <Link className="template-preview-card" to={template.path} key={`${template.title}-${index}`}>
                <div className="template-preview-media">
                  <img src={template.image} alt={`${template.title} email template preview`} loading="lazy" />
                </div>
                <h3>{template.title}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURE CARDS */}
      <section className="feature-cards">
        <div className="card">Beautiful templates</div>
        <div className="card">Fast email editor</div>
        <div className="card">Campaign analytics</div>
        <div className="card">Smart automations</div>
        <div className="card">Deliverability tools</div>
      </section>

      {/* WOW YOUR SUBSCRIBERS */}
      <section className="wow-section">
        <div className="wow-content">
          <h2>AI Email Marketing That Generates Professional Emails in Seconds</h2>
          <p>
            MailSnappy combines AI email marketing with an intelligent email generator to help you create high converting email campaigns faster. Simply describe your campaign, and our AI creates responsive email templates with clean HTML, optimized layouts, compelling copy, and strong call to action sections that are ready to send.
          </p>
          <CTAButton className="primary-btn" kind="templates">Explore templates</CTAButton>
        </div>
        <div className="wow-image">
          <img src={AiEmailMarketing} alt="AI email marketing template preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      {/* AI TEMPLATE DESIGNER */}
      <section className="ai-template-home-section">
        <div className="ai-template-home-copy">
          <span>AI template designer</span>
          <h2>Email List Management and Audience Segmentation Made Easy</h2>
          <p>
A successful email marketing platform starts with better audience management. Organize contacts using tags, custom fields, subscriber activity, and customer behavior to build highly targeted email campaigns. Reach the right audience with personalized emails that improve engagement, increase open rates, and generate more conversions.          </p>
          <CTAButton className="primary-btn" kind="ai">Try AI template designer</CTAButton>
        </div>
        <div className="ai-template-home-preview" aria-label="AI generated email mockup">
          {/* <div className="ai-template-home-window">
            <div className="ai-template-home-dots">
              <i />
              <i />
              <i />
            </div>
            <div className="ai-template-home-email">
              <div className="ai-template-home-banner" />
              <div className="ai-template-home-line wide" />
              <div className="ai-template-home-line" />
              <div className="ai-template-home-button" />
            </div>
          </div> */}
                    <img src={ainew} alt="Email audience segmentation preview" width="640" height="420" loading="lazy" />

        </div>
      </section>

      {/* SEGMENT SECTION */}
      <section className="segment-section">
        <div className="segment-left">
          <h2>Grow Your Email List with Built In Signup Forms</h2>
          <p>
            Build your subscriber base using customizable signup forms, landing forms, and contact imports. Import existing email lists or collect new subscribers directly from your website to grow your audience and create more opportunities for email marketing success.
          </p>
          <CTAButton className="primary-btn" kind="segmentation">Open segmentation tools</CTAButton>
        </div>
        <div className="segment-right">
          <img src={Segment} alt="Email audience segmentation preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      {/* GROW AUDIENCE */}
      <section className="grow-section">
        <div className="grow-left">
          <img src={signup} alt="Email signup form preview" width="640" height="420" loading="lazy" />
        </div>
        <div className="grow-right">
          <h2>Responsive Email Marketing Software for Every Device</h2>
          <p>
            Every email created with MailSnappy is optimized for desktop, tablet, and mobile devices. Build branded newsletters that look professional in every inbox while maintaining fast loading performance and excellent email deliverability.
          </p>
          <CTAButton className="primary-btn" kind="audience">Open audience tools</CTAButton>
        </div>
      </section>

      {/* AUTOMATION SECTION */}
      <div className="autoo-section">
      <section className="auto-section">
        <div className="auto-left">
          <h2>Email Campaign Analytics That Help You Improve Results</h2>
          <p>
            Understand how every email campaign performs with detailed analytics and reporting. Track opens, clicks, engagement, subscriber growth, and campaign performance to make smarter marketing decisions and improve future email campaigns
          </p>
          <CTAButton className="primary-btn" kind="automation">Open automation builder</CTAButton>
        </div>
        <div className="auto-right">
          <img src={sub} alt="Email campaign analytics and subscriber report preview" width="640" height="420" loading="lazy" />
        </div>
      </section>
</div>
      {/* SUPPORT SECTION */}
      <section className="support-section">
        <h2>Email Marketing Support You Can Count On</h2>
        <p>
          Choosing the right email marketing software means having access to reliable support whenever you need it. From onboarding and account setup to campaign optimization and technical guidance, our team helps you get the most from every email you send
        </p>
        <div className="support-card">
          <img src={support} alt="Mailsnappy customer support preview" width="160" height="160" loading="lazy" />
          <p>
            "Mailsnappy made it simple to move from idea to campaign, and the
            support team helped us polish every step."
          </p>
        </div>
      </section>

      {/* BRANDS SECTION */}
      <section className="brands-section">
        <h2>Why MailSnappy Is the Right Email Marketing Platform</h2>
        <p>MailSnappy combines AI email marketing, professional email templates, audience segmentation, subscriber management, <Link className="linkcolor" to="/automation">email automation</Link>, responsive email design, and campaign analytics in one powerful email marketing platform. Everything you need to create, send, automate, and optimize email campaigns is available in one easy to use solution.
Whether you are sending newsletters, promotional emails, product launches, or automated customer journeys, MailSnappy helps you deliver professional email marketing campaigns that drive measurable business growth.
</p>
        <div className="brands-logos product-proof-grid">
          <div><strong>Templates</strong><span>Reusable campaign designs</span></div>
          <div><strong>Automations</strong><span>Welcome and tag-based flows</span></div>
          <div><strong>Reports</strong><span>Opens, clicks, unsubscribes</span></div>
          <div><strong>SES Ready</strong><span>Sender verification tools</span></div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta-section">
        <h2>Start for free today</h2>
        <p>
          Sign up and send your first campaign in minutes. No credit card
          required.
        </p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default Home;
